import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		callingAPI: true,
		searching: '',
		alert_success: false,
		alert_error: false,
		// serverURI: 'http://127.0.0.1:8000',
		serverURI: 'https://infoapi.credipremium.com.br',
		user: null,
		token: null,
		userInfo: {
			messages: [{1: 'test', 2: 'test'}],
			notifications: [],
			tasks: []
		}
	},
	mutations: {
		TOGGLE_LOADING (state) {
			state.callingAPI = !state.callingAPI
		},
		TOGGLE_SEARCHING (state) {
			state.searching = (state.searching === '') ? 'loading' : ''
		},
		SHOW_ALERT_SUCCESS (state) {
			state.alert_success = true;
			setTimeout(function() {
				state.alert_success = false;
			}, 3000);
		},
		SHOW_ALERT_ERROR (state) {
			state.alert_error = true;
			setTimeout(function() {
				state.alert_error = false;
			}, 3000);
		},
		SET_USER (state, user) {
			state.user = user
		},
		SET_TOKEN (state, token) {
			state.token = token
		}
	},
	getters: {

		getHeader: state => {
			let header = {'Content-Type': 'application/json'}
			return header;
		},
		getHeaderAuth: state => {
			let options = {
				headers : {
          'Access-Control-Allow-Origin': '*',
					'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept',
					'Authorization' : state.token
				}
			}
			return options;
		},
    getHeaderAuthParams: state => {
			let options = {
				'Access-Control-Allow-Origin': '*',
				'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept',
				'Authorization' : state.token
			}
			return options;
		}
	}
})



// WEBPACK FOOTER //
// ./src/store/index.js